var exports = {
  "t": "PageDivider__1DsvHU",
};

module.exports = exports;
